// source: src/common/opportunity/oppsetting/oppsetting.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var src_common_opportunity_stage_stage_pb = require('../../../../src/common/opportunity/stage/stage_pb.js');
goog.object.extend(proto, src_common_opportunity_stage_stage_pb);
goog.exportSymbol('proto.loupe.common.opportunity.oppsetting.TeamOppSettings', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loupe.common.opportunity.oppsetting.TeamOppSettings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loupe.common.opportunity.oppsetting.TeamOppSettings.repeatedFields_, null);
};
goog.inherits(proto.loupe.common.opportunity.oppsetting.TeamOppSettings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loupe.common.opportunity.oppsetting.TeamOppSettings.displayName = 'proto.loupe.common.opportunity.oppsetting.TeamOppSettings';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loupe.common.opportunity.oppsetting.TeamOppSettings.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loupe.common.opportunity.oppsetting.TeamOppSettings.prototype.toObject = function(opt_includeInstance) {
  return proto.loupe.common.opportunity.oppsetting.TeamOppSettings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loupe.common.opportunity.oppsetting.TeamOppSettings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.opportunity.oppsetting.TeamOppSettings.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    forecastCategoriesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    stagesList: jspb.Message.toObjectList(msg.getStagesList(),
    src_common_opportunity_stage_stage_pb.Stage.toObject, includeInstance),
    minDealValue: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    maxDealValue: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loupe.common.opportunity.oppsetting.TeamOppSettings}
 */
proto.loupe.common.opportunity.oppsetting.TeamOppSettings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loupe.common.opportunity.oppsetting.TeamOppSettings;
  return proto.loupe.common.opportunity.oppsetting.TeamOppSettings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loupe.common.opportunity.oppsetting.TeamOppSettings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loupe.common.opportunity.oppsetting.TeamOppSettings}
 */
proto.loupe.common.opportunity.oppsetting.TeamOppSettings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeamId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addForecastCategories(value);
      break;
    case 3:
      var value = new src_common_opportunity_stage_stage_pb.Stage;
      reader.readMessage(value,src_common_opportunity_stage_stage_pb.Stage.deserializeBinaryFromReader);
      msg.addStages(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMinDealValue(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMaxDealValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loupe.common.opportunity.oppsetting.TeamOppSettings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loupe.common.opportunity.oppsetting.TeamOppSettings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loupe.common.opportunity.oppsetting.TeamOppSettings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.opportunity.oppsetting.TeamOppSettings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getForecastCategoriesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getStagesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      src_common_opportunity_stage_stage_pb.Stage.serializeBinaryToWriter
    );
  }
  f = message.getMinDealValue();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getMaxDealValue();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
};


/**
 * optional string team_id = 1;
 * @return {string}
 */
proto.loupe.common.opportunity.oppsetting.TeamOppSettings.prototype.getTeamId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.opportunity.oppsetting.TeamOppSettings} returns this
 */
proto.loupe.common.opportunity.oppsetting.TeamOppSettings.prototype.setTeamId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string forecast_categories = 2;
 * @return {!Array<string>}
 */
proto.loupe.common.opportunity.oppsetting.TeamOppSettings.prototype.getForecastCategoriesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.loupe.common.opportunity.oppsetting.TeamOppSettings} returns this
 */
proto.loupe.common.opportunity.oppsetting.TeamOppSettings.prototype.setForecastCategoriesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.loupe.common.opportunity.oppsetting.TeamOppSettings} returns this
 */
proto.loupe.common.opportunity.oppsetting.TeamOppSettings.prototype.addForecastCategories = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loupe.common.opportunity.oppsetting.TeamOppSettings} returns this
 */
proto.loupe.common.opportunity.oppsetting.TeamOppSettings.prototype.clearForecastCategoriesList = function() {
  return this.setForecastCategoriesList([]);
};


/**
 * repeated loupe.common.opportunity.stage.Stage stages = 3;
 * @return {!Array<!proto.loupe.common.opportunity.stage.Stage>}
 */
proto.loupe.common.opportunity.oppsetting.TeamOppSettings.prototype.getStagesList = function() {
  return /** @type{!Array<!proto.loupe.common.opportunity.stage.Stage>} */ (
    jspb.Message.getRepeatedWrapperField(this, src_common_opportunity_stage_stage_pb.Stage, 3));
};


/**
 * @param {!Array<!proto.loupe.common.opportunity.stage.Stage>} value
 * @return {!proto.loupe.common.opportunity.oppsetting.TeamOppSettings} returns this
*/
proto.loupe.common.opportunity.oppsetting.TeamOppSettings.prototype.setStagesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.loupe.common.opportunity.stage.Stage=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loupe.common.opportunity.stage.Stage}
 */
proto.loupe.common.opportunity.oppsetting.TeamOppSettings.prototype.addStages = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.loupe.common.opportunity.stage.Stage, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loupe.common.opportunity.oppsetting.TeamOppSettings} returns this
 */
proto.loupe.common.opportunity.oppsetting.TeamOppSettings.prototype.clearStagesList = function() {
  return this.setStagesList([]);
};


/**
 * optional double min_deal_value = 4;
 * @return {number}
 */
proto.loupe.common.opportunity.oppsetting.TeamOppSettings.prototype.getMinDealValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.loupe.common.opportunity.oppsetting.TeamOppSettings} returns this
 */
proto.loupe.common.opportunity.oppsetting.TeamOppSettings.prototype.setMinDealValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double max_deal_value = 5;
 * @return {number}
 */
proto.loupe.common.opportunity.oppsetting.TeamOppSettings.prototype.getMaxDealValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.loupe.common.opportunity.oppsetting.TeamOppSettings} returns this
 */
proto.loupe.common.opportunity.oppsetting.TeamOppSettings.prototype.setMaxDealValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


goog.object.extend(exports, proto.loupe.common.opportunity.oppsetting);
